import { render, staticRenderFns } from "./MenuListAddNew.vue?vue&type=template&id=27a6014e&"
import script from "./MenuListAddNew.vue?vue&type=script&lang=js&"
export * from "./MenuListAddNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports